module.exports = __webpack_public_path__ + "assets/img/1.983d4a9e.png";